<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [style]="{ 'box-shadow': 'none', 'border': '0', 'width': '600px' }"
  [contentStyle]="{ 'border-radius': '2.2rem', 'padding': '0' }">

  <div class="relative rounded-lg transition-all duration-500 ease-in-out">

    <div class="absolute top-0 left-0 w-full h-[5px] rounded-l-full">
    </div>

    <div class="bg-slate-800 rounded-2xl p-8 text-center text-white">

      <!-- Header Row -->
      <div class="flex items-center justify-center gap-4 mb-4">
        <div class="flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 animate-pulse">
          <i class="pi pi-exclamation-triangle text-red-500 text-3xl"></i>
        </div>
        <div class="text-3xl font-semibold">
          Session Expired
        </div>
      </div>

      <!-- Subtitle -->
      <p class="text-gray-300 text-sm mb-5">
        Your session ended because your account was signed in on another device.
      </p>

      <!-- Message Box -->
      <div class="bg-white/5 border border-white/10 rounded-lg p-4 text-sm text-gray-400 mb-6">
        For your security, we signed you out of this session. If this wasn’t you, please change your password
        immediately.
      </div>

      <!-- Button -->
      <button pButton type="button" label="Return to Login"
        class="w-full !bg-slate-300 !text-black !border-0 py-3 rounded-lg font-light hover:!bg-slate-200"
        (click)="goToLogin()">
      </button>

    </div>
  </div>
</p-dialog>